"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = void 0;
var Anchor;
(function (Anchor) {
    Anchor[Anchor["Before"] = 0] = "Before";
    Anchor[Anchor["After"] = 1] = "After";
})(Anchor || (exports.Anchor = Anchor = {}));
